import { defineStore } from "pinia";
import Services from '@/services/sutting/levelThreeServices'
import { mapList, mapLevelThree } from '@/helpers/mapFuncs'

export const useLevelThreeStore = defineStore("levelThree", {
persist: true,
state:()=>({
    levelThree: {},
    levelThrees: [],
}),
getters : {
    getLevelThree() {
        return mapLevelThree(this.levelThree)
    },
    getLevelThrees() {
        return this.levelThrees.map(mapLevelThree)
    },
    getLevelThreesList() {
        return this.levelThrees.map(mapList)
    }
},
actions : {
    /** Start Sets */
    setLevelThree(levelThree) {
        this.levelThree = levelThree
    },
    setLevelThrees(levelThrees) {
        this.levelThrees = levelThrees
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setLevelThree(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setLevelThrees(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.levelThrees.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.levelThrees[this.levelThrees.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.levelThrees = this.levelThrees.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
